import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f72fac84&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f72fac84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72fac84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f72fac84')) {
      api.createRecord('f72fac84', component.options)
    } else {
      api.reload('f72fac84', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f72fac84&scoped=true", function () {
      api.rerender('f72fac84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notification/index.vue"
export default component.exports